import { render, staticRenderFns } from "./projectSetScoringIndex.vue?vue&type=template&id=001391f5&scoped=true&"
import script from "./projectSetScoringIndex.vue?vue&type=script&lang=js&"
export * from "./projectSetScoringIndex.vue?vue&type=script&lang=js&"
import style0 from "./projectSetScoringIndex.vue?vue&type=style&index=0&id=001391f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001391f5",
  null
  
)

export default component.exports